package dev.youndie.site

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import dev.youndie.site.components.layouts.PageLayoutData
import dev.youndie.site.components.widgets.Chip
import dev.youndie.site.components.widgets.Prompt
import dev.youndie.site.model.BLOG_VISIBLE
import dev.youndie.site.model.GITHUB
import dev.youndie.site.model.SITE_NAME
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Section
import org.jetbrains.compose.web.dom.Text

/**
 * Kobweb's stock error page is bare text on a blank document — no nav, no footer,
 * no way back. Registering our own puts it inside [PageLayout] so a wrong URL
 * still looks like the site.
 *
 * nginx serves `index.html` with a 404 status for unmatched paths, so the router
 * lands here with the original URL intact and the status code stays honest.
 */
@InitKobweb
fun initErrorPage(ctx: InitKobwebContext) {
    ctx.router.setErrorPage(
        layoutId = "dev.youndie.site.components.layouts.PageLayout",
        initRouteMethod = { routeCtx ->
            routeCtx.data.add(
                PageLayoutData(
                    title = "404 — $SITE_NAME",
                    description = "That page does not exist.",
                    noIndex = true,
                )
            )
        },
    ) { NotFoundPage(it) }
}

@Composable
private fun NotFoundPage(ctx: PageContext) {
    Section(attrs = { classes("hero") }) {
        Prompt("cd ${ctx.route.path}")
        H1 { Text("404") }
        Div(attrs = { classes("role") }) { Text("no such file or directory") }

        P { Text("Nothing lives at this address. It may have moved, or it may never have been here.") }

        Div(attrs = { classes("hero-links") }) {
            Chip("/", "home")
            Chip("/about", "about")
            if (BLOG_VISIBLE) Chip("/blog", "blog")
            Chip(GITHUB, "github/youndie")
        }
    }
}
